import dashboard from "./sidebar/dashboard.svg";
import dashboard2 from "./sidebar/dashboard2.svg";

export const Icons = {
  dashboard,
  dashboard2,
};
